import React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

export const GroupMenuItem = ({ selectedRowData, cohortTeamList, setInviteList }) => {
  const handleSelectGroup = (groupID) => {
    const selectedGroup = cohortTeamList?.find((group) => group?.groupID === groupID);

    setInviteList((prev) => ({
      ...prev,
      data: prev?.data?.map((item) => {
        if (item?._id === selectedRowData?._id) {
          return {
            ...item,
            roles: item?.roles?.map((role) => ({
              id: role?.id || uuidv4(),
              groupID: selectedGroup?.groupID,
              groupName: selectedGroup?.name,
              roleName: "",
            })),
          };
        }
        return item;
      }),
    }));
  };

  return (
    <FormControl fullWidth variant="standard">
      <Select
        value={selectedRowData?.roles?.[0]?.groupID || ""}
        onChange={(event) => handleSelectGroup(event.target.value)}
        sx={{ border: 0 }}
        displayEmpty
        renderValue={(val) => {
          const selectedGroup = cohortTeamList?.find((group) => group?.groupID === val);
          return selectedGroup ? <em>{selectedGroup?.name}</em> : <em>Select Group</em>;
        }}
      >
        <MenuItem value="" disabled>
          <em>Select Group</em>
        </MenuItem>
        {cohortTeamList?.map((item, index) => (
          <MenuItem key={index} value={item?.groupID}>
            {item?.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
